module.exports = __webpack_public_path__ + "static/mom-20b9022969cce10eda1193ba12989c5b.jpeg";